import network from '@/services/network';
import { ApiResponse } from '@/types';
import { ErrorResponse } from '@/utils';

// Wizard-Übungsmodus (Practice Mode) — Trockenlauf des Telefonie-Wizards.
// Schreibt serverseitig NUR in wizard_test_runs (kein Customer, kein Case,
// kein Meeting, keine Outbox, keine externen Services). Gating via Feature-
// Flag (Default false) — bei deaktiviert liefert der Server 403. Bewusst
// getrennt vom echten Buchungspfad (bookMeeting/bookForMe), der unveraendert
// bleibt.
const saveTestRun = async (payload: {
  wizard_payload: unknown;
  foerder_result: unknown;
}): Promise<ApiResponse<{ id: number; status: string }>> => {
  try {
    const { data } = await network.post<ApiResponse<{ id: number; status: string }>>(
      '/wizard-sandbox/test-run',
      payload,
    );
    return data;
  } catch (error) { throw new ErrorResponse(error); }
};

// Serverseitiger Status des Übungsmodus. Steuert die Sichtbarkeit des
// Übungsmodus-Buttons im Frontend — der Button erscheint nur bei enabled=true.
// Liefert nur ein Boolean, keine PII.
const getStatus = async (): Promise<{ enabled: boolean }> => {
  try {
    const { data } = await network.get<{ enabled: boolean }>('/wizard-practice/status');
    return data;
  } catch (error) { throw new ErrorResponse(error); }
};

const wizardSandboxApi = {
  saveTestRun,
  getStatus,
};

export default wizardSandboxApi;
